import { useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton, Input } from '../../../layout/form';
import { logOut, registerRoutes } from '../../../func';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const GeneralTab = ({ buyingGroup, refetch }) => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const initValues = useCallback(
    () => ({
      name: buyingGroup?.name || '',
      phone: buyingGroup?.phone || '',
      email: buyingGroup?.email || '',
      website: buyingGroup?.website || '',
    }),
    [buyingGroup]
  );

  const [isEditing, setIsEditing] = useState(false);
  const [values, setValues] = useState(initValues());

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          update: {
            func: values => {
              axios
                .put('/api/v2/buyinggroup/update/one/by/id', {
                  ...authData,
                  ...values,
                })
                .then(result => {
                  dispatch(result.data);
                  refetch();
                })
                .catch(logOut);
            },
          },
        },
        path
      ),
    [path, dispatch, authData]
  );

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  const edit = () => {
    setValues(initValues());
    setIsEditing(true);
  };

  const update = useCallback(() => {
    const { id, stateId, addressLineOne, addressLineTwo, city, zip } =
      buyingGroup;

    const obj = {
      ...values,
      name: values.name.trim(),
      buyingGroupId: id,
      stateId,
      addressLineOne,
      addressLineTwo,
      city,
      zip,
    };

    networkCalls.update(obj);
  }, [values, buyingGroup]);

  const autoAdjustHeight = () => {
    const labelElements = document.querySelectorAll('table#t-labels>tbody>tr');
    const valueElements = document.querySelectorAll('table#t-values>tbody>tr');

    labelElements.forEach((el, index) => {
      valueElements[index].style.height = `${el.clientHeight}px`;
    });
  };

  useEffect(() => {
    if(!buyingGroup) return;
    autoAdjustHeight();
  }, [buyingGroup]);

  useEffect(() => {
    window.addEventListener('resize', autoAdjustHeight);
    return () => {
      window.removeEventListener('resize', autoAdjustHeight);
    };
  }, []);

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <IconButton icon="edit" onClick={edit} />
      </div>
      <div className="row">
        <div className="col s4 m3 l2">
          <table id="t-labels">
            <tbody>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  ID
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Name
                </td>{' '}
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Phone
                </td>{' '}
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Email
                </td>{' '}
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Website
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col s8 m9 l10">
          {buyingGroup ? (
            <table id="t-values" className="highlight">
              {isEditing ? (
                <tbody>
                  <Input
                    id="id"
                    value={buyingGroup?.id}
                    onChange={onChange}
                    disabled={true}
                  />
                  <Input id="name" value={values.name} onChange={onChange} />
                  <Input id="phone" value={values.phone} onChange={onChange} />
                  <Input id="email" value={values.email} onChange={onChange} />
                  <Input
                    id="website"
                    value={values.website}
                    onChange={onChange}
                  />
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td style={{ padding: '4px' }}>{buyingGroup.id}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>{buyingGroup.name}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>
                      {buyingGroup.phone || ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>
                      {buyingGroup.email || ''}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px' }}>
                      {buyingGroup.website || ''}
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          ) : null}
        </div>
      </div>
      {isEditing ? (
        <div className="row">
          <IconButton icon="cancel" onClick={() => setIsEditing(false)} />
          <IconButton icon="save" onClick={update} />
        </div>
      ) : null}
    </div>
  );
};

export default GeneralTab;
